import React, { useCallback, useMemo } from 'react';
import { useCurrentDecedent } from '@/app/providers/DecedentProvider';
import FormConstructor from '@/common/containers/FormConstructor/index';
import Loader from '@/common/components/Loader/index';
import { useQuestionListQuery } from '@/entities/question';

const DecedentDocs = ({ onSubmit, ...props }) => {
  const decedent = useCurrentDecedent();
  const toLocalDateOnly = (value) => {
    if (!value) return null;
    const [datePart] = value.split('T');
    const [year, month, day] = datePart.split('-').map(Number);
    if (!year || !month || !day) return null;
    return new Date(year, month - 1, day);
  };
  const questionListQuery = useQuestionListQuery(
    'basic_document_submission',
    decedent?.id
  );
  const payload = useMemo(() => {
    if (!questionListQuery.data) {
      return {};
    }

    const { list, answers } = questionListQuery.data;
    const formatted = {
      questions: list[0].questions,
      answers,
    };
    const minDate = toLocalDateOnly(decedent.dateOfDeath);
    formatted.questions[0].children[0].answerOptions.properties[1].minDate =
      minDate;
    formatted.questions[1].children[0].answerOptions.properties[1].minDate =
      minDate;
    formatted.questions[2].children[0].answerOptions.properties[1].minDate =
      minDate;
    formatted.questions[3].children[0].answerOptions.properties[1].minDate =
      minDate;

    return formatted;
  }, [decedent?.dateOfDeath, questionListQuery.data]);
  const formKey = String(questionListQuery.dataUpdatedAt || '1');

  const handleSubmit = useCallback(
    async (form) => {
      await onSubmit(form);
      await questionListQuery.refetch();
    },
    [onSubmit, questionListQuery]
  );

  return payload.questions ? (
    <FormConstructor
      {...props}
      onSubmit={handleSubmit}
      questions={payload.questions}
      answers={payload.answers}
      key={formKey}
    />
  ) : (
    <Loader />
  );
};

export default DecedentDocs;
